import { render, staticRenderFns } from "./AssuranceTypeChange.vue?vue&type=template&id=dafe4e24&scoped=true"
import script from "./AssuranceTypeChange.vue?vue&type=script&lang=js"
export * from "./AssuranceTypeChange.vue?vue&type=script&lang=js"
import style0 from "./AssuranceTypeChange.vue?vue&type=style&index=0&id=dafe4e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafe4e24",
  null
  
)

export default component.exports